import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { LogoutService } from './logout.service';
import { ToastrService } from 'ngx-toastr';
import { debug } from 'util';
import { LocalService } from '../local.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
  postresult: boolean;

  constructor(private authService: AuthService, private router: Router, private logoutservice: LogoutService
    , private toastr: ToastrService, private localService: LocalService) { }

  ngOnInit() {
    
    if (localStorage.getItem("LoggedIn") == null || localStorage.getItem("LoggedIn") == undefined) {
      localStorage.clear();
      
      // Clear the localStorage
      this.localService.clearToken();

      this.router.navigate(["login"]);
    }
    else {
 //var logid = localStorage.getItem("logid");
 var logid = this.localService.getJsonValue("logid");
    var returnedid = this.logoutservice.logout(logid).subscribe(res => {
      //console.log(res);
      if (res.status == 200) {
        this.postresult = true;
        localStorage.clear();

        // Clear the localStorage
        this.localService.clearToken();

        localStorage.removeItem("LoggedIn");
        this.router.navigate(["login"]);
      };

    },
      error => {
        this.toastr.error(error.error);
        this.postresult = false
      })
    }
   
    // this.authService.logout();
    //this.router.navigate(['login']);
  }

}
